import { CardWrap } from '.././CardWrap';
import * as S from './PerformanceCard.styled';

// TO-DO: test with large number of day (for example 1923) - the chart has a sharp
// pick before the last value, because all prev dots contains sums of data values and it looks
// like there were a dramatic decrease. From the other hand, if instead of sum, we'll use
// an avarage – we can smoothen real "picks" and the chart won't represent the reality
export const PerformanceCard = ({
  label,
  value = 0,
  change = 0,
  trend = '', // 'up', 'down' or ''
  data,
  numCols,
}) => {
  return (
    <CardWrap numCols={numCols} style={{ display: 'flex', flexDirection: 'column' }}>
      <S.Title>{label}</S.Title>
      <S.Value>{formatStatValue(value, label)}</S.Value>
      <S.ChangeTitle>vs last 30d</S.ChangeTitle>
      <S.ChangeValue trend={trend}>{change ? change + '%' : '–'}</S.ChangeValue>
      <Graph data={data} trend={trend} />
    </CardWrap>
  );
};

const GRAPH_CONFIG = {
  maxPoints: 30,
  height: 40,
  width: 100,
  padding: 2,

  get baseline() {
    return this.height - this.padding;
  },
  get innerHeight() {
    return this.height - this.padding * 2;
  },
};

// data = [ 1, 2, 3, ... ]
function Graph({ data, trend }) {
  const { height, width, padding, baseline, innerHeight } = GRAPH_CONFIG;
  const values = formatGraphData(data);
  const maxValue = Math.max(...values);
  const step = values.length > 1 ? width / (values.length - 1) : 0;

  const points = values.map((value, index) => {
    const x = index * step;
    const y = maxValue ? padding + innerHeight - (innerHeight / maxValue) * value : baseline;
    return { x, y };
  });

  const pathData = points
    .map(({ x, y }, index) => `${index === 0 ? 'M' : 'L'} ${x}, ${y}`)
    .join(' ');
  const areaPathData = `${pathData} L ${width}, ${baseline} L 0, ${baseline} Z`;

  return (
    <S.GraphWrap trend={trend}>
      <svg width='100%' height='100%' viewBox={`0 0 ${width} ${height}`} preserveAspectRatio='none'>
        <S.GraphFill d={areaPathData} trend={trend} />
        <path
          d={pathData}
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinejoin='round'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
    </S.GraphWrap>
  );
}

function formatGraphData(data) {
  let values = data.map((value) => Number(value));

  while (values.length > GRAPH_CONFIG.maxPoints) {
    values = values.reduce((result, value, index) => {
      if (index % 2 === 0) {
        result.push(value + (values[index + 1] ?? 0));
      }

      return result;
    }, []);
  }

  return values;
}

function formatStatValue(value, metric) {
  let prefix = '';
  let postfix = '';

  if (metric === 'Cost') prefix = '$';
  if (metric === 'eCPM') prefix = '$';
  if (metric === 'Revenue') prefix = '$';
  if (metric === 'Convertion rate') postfix = '%';

  return prefix + formatNumber(value) + postfix;
}

function formatNumber(number) {
  const suffixes = ['', 'K', 'M', 'B']; // thousands, millions, billions

  const suffixIndex = Math.floor(Math.log10(number) / 3);
  const scaledNumber = suffixes[suffixIndex] ? number / Math.pow(10, suffixIndex * 3) : number;
  let formattedNumber = scaledNumber?.toFixed(2);

  if (formattedNumber?.indexOf('.') !== -1) {
    formattedNumber = formattedNumber?.replace(/\.?0*$/, '');
  }

  return formattedNumber + (suffixes[suffixIndex] ? suffixes[suffixIndex] : '');
}
